import React from "react";
import { View, Platform, StyleSheet, ScrollView, Text } from "react-native";

import Header from "../../../common/header/index";
import appStyles from "../../../../appStyles";
import appPages from "../../../../../appPages";
import AppTheme from "../../../AppTheme";
import { MoodColors } from "../../../common/mood/MoodsHelper";
import DownloadButtons from "./DownloadButtons";

export default function Reconnect({ account, controller, goBack = () => {} }) {
  return (
    <View style={[appStyles.container, { backgroundColor: "#FFF" }]}>
      <Header
        title="Reconnect App"
        subTitle={account}
        goBack={goBack}
        returnPage={appPages.integrationsV2}
      />

      <ScrollView
        style={(appStyles.scrollView, { paddingHorizontal: 16 })}
        contentContainerStyle={appStyles.scrollViewContent}
      >
        <Text style={styles.sectionText}>
          We’re having trouble connecting to your account
        </Text>

        <Text style={styles.label}>Reconnect Desktop Sync:</Text>

        <Text style={[styles.text, { marginBottom: 16 }]}>
          1. Launch the Mana app on your desktop
        </Text>
        <Text style={[styles.text, { marginBottom: 12 }]}>
          2. If you don’t see Mana, download and install the app using the links
          below:
        </Text>

        <DownloadButtons controller={controller} />
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  label: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: "#8B92A1",
    marginBottom: 8,
    marginTop: 16,
  },
  text: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
  },
  linkText: {
    color: AppTheme.DEFAULT_COLOR,
    fontWeight: "600",
    marginBottom: 8,
  },
  sectionText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: MoodColors.VeryBad,
    marginTop: 16,
    textAlign: "center",
  },
});
